import { useEffect, useRef, useState } from "react";
import React from "react";
import "./style.scss";
import { useWindowSize } from "@app/Helpers";
import Button from "@components/Button";
import Featured1 from "../../img/Featured1.svg?react";
import Featured2 from "../../img/Featured2.svg?react";
import Featured3 from "../../img/Featured3.svg?react";
import Contact1 from "./img/Contact1.svg?react";
import Contact2 from "./img/Contact2.svg?react";

export default function SubscriptionFooter({ hasSubscription }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  return (
    <div
      className={`subscription-footer ${hasSubscription ? "has-subscription" : ""}`}
    >
      {hasSubscription ? (
        <div className="sub-contact">
          <h4 className="sub-title">Direkter Kundenservice</h4>
          <p className="sub-copy">Exklusiv erreichbar für unsere Abonnenten.</p>
          <div className="sub-contact-info">
            <div className="sub-info-item">
              <Contact1 />
              <p className="contact-phone">
                +49 165 1616 1616
                <span>10:00 – 16:00 Uhr</span>
              </p>
            </div>
            <div className="sub-info-item">
              <Contact2 />
              premiumabo@vuse.com
            </div>
          </div>
        </div>
      ) : (
        <div className="sub-benefits">
          <h4 className="sub-title">
            Vorteile vom Premium<strong>Abo</strong>
          </h4>
          <div className="sub-benefits-items">
            <div className="sub-benefit-item">
              <Featured1 />
              Monatliche Lieferung
            </div>
            <div className="sub-benefit-item">
              <Featured2 />
              Bis zu 30% sparen
            </div>
            <div className="sub-benefit-item">
              <Featured3 />
              Flexibel, änderbar,
              <br /> jederzeit kündbar.
            </div>
          </div>
          <Button
            href={`${import.meta.env.VITE_VUSE_URL}/vorteils-abo/?utm_source=IC&utm_medium=Dashboard&utm_campaign=PremiumAbo`}
            btnClass="ultra-insider"
          >
            Zum PremiumAbo
          </Button>
        </div>
      )}
    </div>
  );
}
